import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import { getEmploymentStatuses } from "../../actions/userActions/employmentStatusAction";
import Loader from "../subComponents/Loader";
import Search from "../subComponents/search/Search";
import AddButton from "../subComponents/buttons/AddButton";
import { IconButton, Tooltip } from "@mui/material";
import Pagination from '../paginatioin/pagination';
import EditButton from "../subComponents/buttons/EditButton";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import HeaderComponent from "../reuse_components/HeaderComponent";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import Heading6Regular from "../designSystem/Heading6Regular";
import SearchInput from "../subComponents/search/SearchInput";
import CustomPagination from "../subComponents/pagination/CustomPagination";
import CustomButton from "../subComponents/buttons/CustomButton";

import thIcon from "../../assets/images/thIcon.svg";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import DynamicTable from "../reuse_components/DynamicTable";
import BodyExtraSmallMedium from "../designSystem/BodyExtraSmallMedium";
import AddEmploymentStatuses from "./AddEmploymentStatuses";
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function EmploymentStatuses() {
  const query = useQuery();
  const [isExpanded, setIsExpanded] = useState(false);
  const initialPageNumber = parseInt(query.get("page")) || 1;
  const [currentPageNumber, setCurrentPageNumber] = useState(initialPageNumber);
  const [searchQuery, setSearchQuery] = useState(query.get("search") || "");
  const [previousQuery, setPreviousQuery] = useState("");
  const [permission, setPermission] = useState(false)
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [EmployementStatusData, setEmployementStatusData] = useState([]);

  const itemsPerPage = 10;
  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };
  const dispatch = useDispatch();
  const history = useHistory();

  const pageSize = 10;
  useEffect(() => {
    const pageNumber = currentPageNumber;

    if (searchQuery !== previousQuery) {
      setCurrentPageNumber(1);
    }
    dispatch(getEmploymentStatuses(currentPage, itemsPerPage, searchQuery));
    setPreviousQuery(searchQuery);
    setButtonPermission()
  }, [currentPage, searchQuery]);

  const employmentStatuses = useSelector(
    (state) => state.employmentStatuses_reducer.employmentStatuses
  );
  console.log(employmentStatuses, "employement status");

  const totalPages = employmentStatuses?.totalPages || 0;
  const totalItems = employmentStatuses?.totalCount || 0;

  const permissions = JSON.parse(localStorage.getItem("permissionsList"));

  useEffect(() => {
    const EmploymentStatusData =
      employmentStatuses && employmentStatuses?.result?.map((employmentStatuses) => ({
        ...employmentStatuses,
        status: (
          <span
            style={{
              background: "#4361FF1A",
              width: "56px",
              height: "26px",
              padding: "3px 8px",
              display: "inline-block",
              textAlign: "center",
              lineHeight: "20px",
              borderRadius: "4px 0px 0px 0px",
              opacity: 1,
            }}
          >
            {employmentStatuses.active ? "Active" : "Inactive"}
          </span>
        ),
      })) || [];
    setEmployementStatusData(EmploymentStatusData);
  }, [employmentStatuses]);

  // const EmploymentStatusData = employmentStatuses && employmentStatuses?.result;
  // const EmploymentStatusesData = EmploymentStatusData?.map((employmentStatuses) => ({
  //   ...employmentStatuses,
  //   status: (
  //     <span
  //       style={{
  //         background: "#4361FF1A",
  //         width: "56px",
  //         height: "26px",
  //         padding: "3px 8px",
  //         display: "inline-block",
  //         textAlign: "center",
  //         lineHeight: "20px",
  //         borderRadius: "4px 0px 0px 0px",
  //         opacity: 1 ,
  //       }}
  //     >
  //       {employmentStatuses.active ? "Active" : "Inactive"}
  //     </span>
  //   ),
  // }));
  const columns = [
    { label: "Name", accessor: "name" },
    { label: "Description", accessor: "description" },
    { label: "Status", accessor: "status" },
  ];

  const handleAddEmployeementStatusClick = () => {
    setEditData(null);
    setShowModal(true);
  };

  const handleEditEmploymentStatus = (row) => {
    setEditData(row);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };
  const handleSaveData = async () => {
    dispatch(getEmploymentStatuses(currentPage, itemsPerPage, searchQuery));
    setShowModal(false);
  };
  const actions = [
    {
      label: 'Edit Employment status',
      icon: <EditOutlinedIcon />,
      permission: 'CanUpdateEmploymentStatus',
      handler: handleEditEmploymentStatus,
    },
  ];

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };
  const setButtonPermission = () => {
    if (permissions.includes('CanAddEmploymentStatus')) {
      setPermission(true);
    }
  }

  return (
    <>

      <div>
        <div className="main-container">
          <div className="content-header">
            <div className="header-navigation">
              <BodySmallMedium text="Manage" color="#A1A2A4" />
              <img
                src={chevron_rightIcon} alt="Chevron Right" className="chevron-right-icon" />
              <BodySmallMedium text="Employment Status" color="#1E293B" />

            </div>
          </div>
          <Heading6Regular text="Employment Status" color="#1E293B" />
          <div className="content-wrapper">
            <div className="pagination">
              <SearchInput
                placeholder="Search"
                onChange={handleSearchChange}
                value={searchQuery}
              />
              <div style={{ display: "flex", alignItems: "center" }}>
                <CustomPagination
                  currentPage={currentPage}
                  totalItems={totalItems}
                  itemsPerPage={itemsPerPage}
                  totalPages={totalPages}
                  onPageChange={(page) => setCurrentPage(page)}
                />

                {permissions && permissions.includes("CanAddEmploymentStatus") && (
                  <CustomButton text="Add Employment Status" width="180px" onClick={handleAddEmployeementStatusClick} />
                )}
              </div>
            </div>
            <DynamicTable
              data={EmployementStatusData}
              isLoading={employmentStatuses === "isLoading"}
              columns={columns}
              permissions={permissions}
              actions={actions}
              thIcon={thIcon}
            />
            <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
              {totalItems > 0 && (
                <CustomPagination
                  currentPage={currentPage}
                  totalItems={totalItems}
                  itemsPerPage={itemsPerPage}
                  totalPages={totalPages}
                  onPageChange={(page) => setCurrentPage(page)}
                />
              )}
            </div>
          </div>

        </div>

        {showModal && (
          <AddEmploymentStatuses
            onClose={handleCloseModal}
            editData={editData}
            onSave={handleSaveData}
          />
        )}
      </div>

    </>
  );
}

export default EmploymentStatuses;
